<div class="saved-overlay" *ngIf="open">
    <div class="saved-dialog">
        <button class="close-btn" (click)="close()">&#x2715;</button>
        <div class="saved-body">
            <div class="check-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="12" fill="#6DD16E" />
                    <path d="M7 12.5L10.5 16L17 9" stroke="white" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </div>
            <span>Your changes have been saved.</span>
        </div>
    </div>
</div>